import { render, staticRenderFns } from "./ClientUsage.vue?vue&type=template&id=2db5034d&"
import script from "./ClientUsage.vue?vue&type=script&lang=ts&"
export * from "./ClientUsage.vue?vue&type=script&lang=ts&"
import style0 from "./ClientUsage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QChip,QIcon} from 'quasar'
component.options.components = Object.assign({QChip,QIcon}, component.options.components || {})
